import { Card, CardContent, CardHeader, CardTitle } from "@/components/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/table";
import type { JiraMetricsAgingWIPPoint } from "@/http/api-types";

export function AgingWipTable({ rows }: { rows: JiraMetricsAgingWIPPoint[] }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Aging WIP (Open Tickets)</CardTitle>
      </CardHeader>
      <CardContent className="overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Ticket</TableHead>
              <TableHead>Assignee</TableHead>
              <TableHead>Open Workdays</TableHead>
              <TableHead>Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.slice(0, 20).map(row => (
              <TableRow key={row.ticket_key}>
                <TableCell>
                  <a
                    href={`https://remerge.atlassian.net/browse/${row.ticket_key}`}
                    target="_blank"
                    rel="noreferrer"
                    className="text-sky-600 hover:text-sky-700 hover:underline"
                  >
                    {row.ticket_key}
                  </a>
                </TableCell>
                <TableCell>{row.assignee || "-"}</TableCell>
                <TableCell>{row.open_days.toFixed(1)}</TableCell>
                <TableCell>{row.status || "-"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
